import React from 'react';
import {useTranslate} from 'ra-core';


export const useEnumSelectChoices = (enumObj, enumName) => {
	const t = useTranslate();

	const choices = React.useMemo(() => Object.keys(enumObj).map(key => ({id: enumObj[key], name: t(`osfc.enums.${enumName}.${key}`)})), [t]);
	return choices;
};